<template>
  <div class="icon_inp clearfix">
    <div class="icon" @click="getUserPosition()">
      <img src="/vue/images/local_icon.png">
    </div>
    <div class="div_relative">
      <span v-on:click="$parent.$parent.correctLabel($event)">{{ $store.getters.cv_t(label) }}</span>
      <input
        class="pac-input"
        :name="name"
        v-model.trim="address"
        @input="input()"
        v-validate="'required|min:3|max:255'"
        :class="{ invalid: errors.first( name ) }"
        autocomplete="off"
        required
        type="text"
        v-on:input="$parent.$parent.correctLabel($event);"
        v-on:keyup.tab="$parent.$parent.correctLabel($event)"
        v-on:click="$parent.$parent.correctLabel($event)"
      >
    </div>
    <br>
    <br>
    <div class="map" style="width: 100%; height: 250px;"></div>
  </div>
</template>
<script>
import mapConfig from "./GoogleMapConfig";

export default {
  data() {
    return {
      language: {
        am: "HY",
        ru: "RU",
        en: "EN"
      },
      position: {
        lat: 0,
        lng: 0
      },
      customWatch: true,
      address: "",
      map: {},
      marker: {},
      geocoder: {}
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    lat: {
      type: Number,
      default: 40.1842
    },
    lng: {
      type: Number,
      default: 44.5223
    },
    adds: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    getUserPos: {
      type: Boolean,
      default: false
    },
    callback: Function
  },
  model: {
    prop: "adds",
    event: "input"
  },
  watch: {
    lat(to, from){
      if(this.customWatch){
        this.customWatch = false
        this.changeMapPosition(this.lat, this.lng)
      }
    },
    lng(to, from){
      if(this.customWatch){
        this.customWatch = false
        this.changeMapPosition(this.lat, this.lng)
      }
    },
    adds(to, from){
      this.address = to
    }
  },
  mounted() {
    this.address = this.adds
    if (!mapConfig.script.created) {
      mapConfig.script.created = true;
      var script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDvvqgc0KhI8v-1cqDl2lbDpy12TFVKe_U&libraries=places&language=${
        this.language[this.$store.getters.locale]
      }`;
      script.setAttribute("loaded", true);
      script.setAttribute("async", "");
      script.setAttribute("defer", "");
      document.getElementsByTagName("head")[0].appendChild(script);
      script.onload = () => {
        mapConfig.script.loaded = true;
        this.myMap();
      };
    } else {
      var interval = setInterval(() => {
        if (mapConfig.script.loaded) {
          this.myMap();
          clearInterval(interval);
        }
      }, 10);
    }
  },
  methods: {
    input(){
      this.$emit('input', this.address)
    },
    resetErrors(){
      this.$validator.reset();
    },
    myMap() {
      var searchBox = new google.maps.places.SearchBox(
        this.$el.querySelector(".pac-input")
      );

      var myCenter = new google.maps.LatLng(this.lat, this.lng);
      var mapCanvas = this.$el.querySelector(".map");
      var mapOptions = {
        center: new google.maps.LatLng(this.lat, this.lng),
        zoom: 12,
        disableDefaultUI: true,
        fullscreenControl: true
      };

      this.geocoder = new google.maps.Geocoder();
      this.map = new google.maps.Map(mapCanvas, mapOptions);
      this.marker = new google.maps.Marker({
        position: myCenter,
        map: this.map,
        draggable: true
      });
      this.map.addListener("dragend", this.customDrag);
      this.marker.addListener("dragend", this.customDrag);
      google.maps.event.addListener(searchBox, "places_changed", e => {
        searchBox.set("map", null);

        var places = searchBox.getPlaces();

        var bounds = new google.maps.LatLngBounds();
        var i, place;
        for (i = 0; (place = places[i]); i++) {
          (place => {
            this.address = place.formatted_address;
            this.marker.setPosition(place.geometry.location);
            this.marker.bindTo("map", searchBox, "map");
            bounds.extend(place.geometry.location);
          })(place);
        }
        this.map.fitBounds(bounds);
        searchBox.set("map", this.map);
        this.map.setZoom(Math.min(this.map.getZoom(), 12));
        this.callback({
          lat: this.map.center.lat(),
          lng: this.map.center.lng(),
          address: this.address
        });
      });

      if (this.getUserPos) {
        this.getUserPosition();
      } else {
        this.getAddress(myCenter).then(res => {
          this.address = res === 'ZERO_RESULTS' ? this.adds : res;
        });
        this.callback({
          lat: this.lat,
          lng: this.lng,
          address: this.address
        });
      }
      this.marker.setMap(this.map);
    },
    getUserPosition() {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    },
    changePosition(lat, lng, watch = false) {
      var latLng = new google.maps.LatLng(lat, lng);
      this.map.setCenter(latLng, 12);
      this.marker.setPosition(latLng);
      this.getAddress(latLng).then(res => {
        if (res) {
          this.address = res;
        }
        this.callback({
          lat,
          lng,
          address: this.address
        });
        if(watch){
          this.customWatch = true
        }
      });
    },
    changeMapPosition(lat, lng){
      if(!lat && !lng){
        lat = this.position.lat
        lng = this.position.lng
      }
      var latLng = new google.maps.LatLng(lat, lng);
      this.map.setCenter(latLng, 12);
      this.marker.setPosition(latLng);
      setTimeout(() => {
        this.customWatch = true
      },10)
    },
    customDrag(e) {
      var lat = this.map.center.lat();
      var lng = this.map.center.lng();
      if (e) {
        lat = e.latLng.lat();
        lng = e.latLng.lng();
      }
      this.changePosition(lat, lng);
    },
    showPosition(position) {
      this.position.lat = position.coords.latitude;
      this.position.lng = position.coords.longitude;
      this.changePosition(this.position.lat, this.position.lng);
    },
    getAddress(latLng) {
      return new Promise((res, rej) => {
        this.geocoder.geocode({ latLng: latLng }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              res(results[0].formatted_address);
            } else {
              res("No results");
            }
          } else {
            res(status);
          }
        });
      });
    }
  }
};
</script>
<style scoped>
.map {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/GoogleMap.vue